import React, { Component, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import About from './About.tsx';
import Works from './Works.tsx';
import Contact from './Contact.tsx';
import { AnimatePresence } from 'framer-motion'; 
import '../css/TopBar.css'; // Assuming callHello is exported from model/TopBar.tsx



class TopBar extends Component{

  render() {
    return (
      <div className="topbar">
        <AppBar position='static' style={{ backgroundColor: 'black' }}>
          <Toolbar>
            <AnimatePresence>
              <About/>
              <Works/>
              <Contact/>
            </AnimatePresence>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}
export default TopBar;